/**
 * Created by tschenkel on 8/31/2015.
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveBranchingLiveEnvironment } from "./LiveBranchingLiveEnvironment";

export class LiveBranchingPreClientEnvironment extends LiveBranchingLiveEnvironment {
    public static LIVE_BRANCHING_PRE_CLIENT_ENVIRONMENT_ID: string = "LiveBranchingPreClientEnvironment";

    constructor() {
        super(LiveBranchingPreClientEnvironment.LIVE_BRANCHING_PRE_CLIENT_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-netconf/{gameId}/{networkId}.xml";
        }

        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";

        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/language/{gameId}/cldr";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config-preClient/version/{gameId}/version.json";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches-preClient/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://" + BasicConstants.DOMAIN_INTERNAL_DNS + "/web/Web_PreClient/branches-preClient/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isLiveBranchingEnvironment && this._data.globals.isPreClient;
    }
}
